var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mb-2 item",
      class: { current: _vm.isCurrent },
      style: _vm.styles,
      on: { click: _vm.onSelect },
    },
    [
      _c("div", { staticClass: "d-flex justify-content-between" }, [
        _c("span", { staticClass: "item-title font-weight-bold" }, [
          _c(
            "span",
            {
              staticClass: "contact",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm.filemakerId
                ? _c("span", { staticClass: "filemaker-id" }, [
                    _vm._v(_vm._s(_vm.filemakerId) + " "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "contact-full-name" }, [
                _vm._v(_vm._s(_vm._f("uppercase")(_vm.contactFullName))),
              ]),
              _vm._v(" "),
              _vm.lastOutgoingMessageHasError
                ? _c(
                    "span",
                    [
                      _c(
                        "el-tooltip",
                        { attrs: { placement: "top", effect: "light" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                "\n                        Sending error\n                      "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "cursor-pointer",
                              staticStyle: { color: "#FFA500" },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-exclamation-circle",
                              }),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.hasUnread
          ? _c(
              "span",
              {
                staticClass:
                  "badge badge-danger badge-pill badge-smallest align-self-start mr-2",
              },
              [_vm._v(_vm._s(_vm.unreadCount))]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-row d-flex justify-content-between" }, [
        _c("span", [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("uppercase")(_vm.outgoingNumberTitle)) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.hasMessages
          ? _c("span", [
              _vm._v(_vm._s(_vm._f("uppercase")(_vm.lastMessageDirectionText))),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-row d-flex justify-content-between" }, [
        _c("span", [
          _vm._v(
            "\n              (" +
              _vm._s(_vm._f("uppercase")(_vm.outgoingNumberPhoneNumber)) +
              ")\n          "
          ),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm._f("uppercase")(_vm.lastInteraction)))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }